import React from "react";
import TagsInput from "react-tagsinput";
import {
    Container,
    Row,
    Col,
    Card,
    FormInput,
    FormSelect,
    FormCheckbox,
    FormTextarea,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import {
    requestProfilPractitioner,
    synchronisePlatform,
    updatePractitionerData
} from "../../actions/practitioners.action";
import {resetPasswordUser} from "../../actions/users.action";
import {connect} from "react-redux";
import dateFormat from "dateformat";
import CardStat from "../../components/stats/CardStat";
import CardProgress from "../../components/stats/CardProgress";
import CopyText from "../../components/form/CopyText";
import {getChannels, getCivilities, convertDateToDash} from "../../utils/tools";
import {requestSpecialties} from "../../actions/specialties.action"
import {requestConventions} from "../../actions/conventions.action";

class Profil extends React.Component {
    constructor(props) {
        super(props);
        let uuid = this.props.match.params.id;
        this.props.loadData(uuid);
        this.props.loadSpecialties();
        this.props.loadConventions();
        this.state = {
            last_name: '',
            first_name: '',
            email: '',
            phone: '',
            birth_date: '',
            rpps: '',
            adeli: '',
            description: '',
            practice_phone: '',
            practice_address: '',
            practice_zip_code: '',
            practice_city: '',
            secured_email: '',
            country: '',
            convention: '',
            main_specialty: '',
            specialties: '',
            territorial_organization_type: '',
            territorial_organization_name: '',
            iban: '',
            billingContacts: ''
        }
        this.addBillingContacts = this.addBillingContacts.bind(this);
        this.removeContact = this.removeContact.bind(this);
        this.setRestricted = this.setRestricted.bind(this);
        this.enableInstantAppointment = this.enableInstantAppointment.bind(this);
        this.enableAutoConfirm = this.enableAutoConfirm.bind(this);
        this.enableFSE = this.enableFSE.bind(this);
        this.enableSearchPatient = this.enableSearchPatient.bind(this);
        this.enableCardPayment = this.enableCardPayment.bind(this);
        this.resetPasswordUser = this.resetPasswordUser.bind(this);
        this.syncPlatform = this.syncPlatform.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeArray = this.handleChangeArray.bind(this);
    }

    componentDidMount() {
        this.setState({
            civility: this.props.practitioners.data.civility,
            email: this.props.practitioners.data.email,
            phone: this.props.practitioners.data.phone,
            last_name: this.props.practitioners.data.last_name,
            first_name: this.props.practitioners.data.first_name,
            birth_date: this.props.practitioners.data.birth_date,
            rpps: this.props.practitioners.data.rpps,
            adeli: this.props.practitioners.data.adeli,
            description: this.props.practitioners.data.description,
            practice_phone: this.props.practitioners.data.practice_phone,
            practice_address: this.props.practitioners.data.practice_address,
            practice_zip_code: this.props.practitioners.data.practice_zip_code,
            practice_city: this.props.practitioners.data.practice_city,
            secured_email: this.props.practitioners.data.secured_email,
            country: this.props.practitioners.data.country,
            convention: this.props.practitioners.data.convention,
            main_specialty: this.props.practitioners.data.main_specialty,
            specialties: this.props.practitioners.data.specialties,
            iban: this.props.practitioners.data.iban,
            territorial_organization_type: this.props.practitioners.data.territorial_organization_type,
            territorial_organization_name: this.props.practitioners.data.territorial_organization_type,
            billingContacts: this.props.practitioners.data.billingContacts
        })
    }

    calculateProfilePercentage = (data) => {
        let profilData = {
            'civility': data.civility,
            'birth': data.birthdate,
            'convention': data.convention,
            'am': data.health_insurance_number,
            'speciality': data.speciality,
            'num': null
        };
        if (data.adeli) {
            profilData.num = data.adeli;
        } else if (data.rpps) {
            profilData.num = data.rpps;
        }

        const profileObjLength = Object.keys(profilData).length;
        const profileObjNullLength = Object.keys(profilData).filter((key) => {
            return profilData[key] !== null;
        }).length;
        const profilePercentage = Math.round((profileObjNullLength * 100) / profileObjLength);
        return profileObjLength < profileObjNullLength ? 1 : profilePercentage;
    }
    updateDetails = () => {
        if (!this.props.users.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                civility: this.state.civility,
                lastName: this.state.last_name,
                firstName: this.state.first_name,
                phone: this.state.phone,
                email: this.state.email,
                birthDate: convertDateToDash(this.state.birth_date),
                rpps: this.state.rpps,
                adeli: this.state.adeli,
                description: this.state.description,
                practice_phone: this.state.practice_phone,
                practice_address: this.state.practice_address,
                practice_zip_code: this.state.practice_zip_code,
                practice_city: this.state.practice_city,
                secured_email: this.state.secured_email,
                country: this.state.country,
                convention: this.state.convention,
                main_specialty: this.state.main_specialty,
                specialties: this.state.specialties,
                territorial_organization_type: this.state.territorial_organization_type,
                territorial_organization_name: this.state.territorial_organization_name,
                iban: this.state.iban,
                billingContacts: this.state.billingContacts
            };
            this.props.updatePractitioner(payload);
        }
    }

    handleChange(event) {
        let name = event.target.name;
        this.setState({[name]: event.target.value});
    }

    addBillingContacts(event) {
        event.preventDefault();
        if (event.target.querySelector("input[type='email']").value) {
            let newContact = event.target.querySelector("input[type='email']").value;
            this.props.practitioners.data.billing_contacts.push({
                'email': newContact
            })
            this.setState({
                ['billingContacts']: this.props.practitioners.data.billing_contacts
            });
        }
    }

    removeContact(event) {
        let email = event.target.parentElement.parentElement.getAttribute("data-email");
        this.props.practitioners.data.billing_contacts = this.props.practitioners.data.billing_contacts.filter(function (contact) {
            return contact.email !== email
        });
        this.setState({['billingContacts']: this.props.practitioners.data.billing_contacts});
    }

    handleChangeArray(event) {
        let name = event.target.name;
        let value = Array.from(event.target.selectedOptions, option => option.value);
        this.setState({[name]: value});
    }

    resetPasswordUser(event) {
        event.preventDefault();
        if (!this.props.users.loading) {
            let payload = {
                id: this.props.practitioners.data.id
            };
            this.props.resetPassword(payload);
        }
    }

  syncPlatform(event) {
    event.preventDefault();
    if (!this.props.users.loading) {
      let payload = {
        id: this.props.practitioners.data.id
      };
      this.props.syncPlatform(payload);
    }
  }

    setRestricted(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                restricted: !this.props.practitioners.data.is_restricted
            };
            this.props.updatePractitioner(payload);
        }
    }

    enableInstantAppointment(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                instantEncountersEnabled: !this.props.practitioners.data.instant_encounters_enabled
            };
            this.props.updatePractitioner(payload);
        }
    }

    enableAutoConfirm(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                autoConfirmAppointment: !this.props.practitioners.data.auto_confirm_appointment
            };
            this.props.updatePractitioner(payload);
        }
    }

    enableFSE(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                claimFormEnabled: !this.props.practitioners.data.claim_form_enabled
            };
            this.props.updatePractitioner(payload);
        }
    }

    enableSearchPatient(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                searchable: !this.props.practitioners.data.searchable
            };
            this.props.updatePractitioner(payload);
        }
    }

    enableCardPayment(event) {
        event.preventDefault();
        if (!this.props.practitioners.loading) {
            let payload = {
                id: this.props.practitioners.data.id,
                cardPaymentActivated: !this.props.practitioners.data.card_payment_activated
            }
            this.props.updatePractitioner(payload)
        }
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                {
                    this.props.practitioners.fetching ||
                    this.props.specialties.fetching ||
                    this.props.conventions.fetching
                        ?
                        (
                            <div className="flex-center">
                                <div className="text-center d-block">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <Row noGutters className="page-header pt-4 fixed">
                                    <PageTitle
                                        title={this.props.practitioners.data.first_name + ' ' + this.props.practitioners.data.last_name}
                                        subtitle="Profil" className="text-sm-left mb-3"/>
                                </Row>
                                <Row>
                                    <Col lg="12" className="mx-auto mt-4">
                                        <Row>
                                            <Col lg="4" className="mx-auto">
                                                <Card small className="edit-user-details">
                                                    <CardHeader className="border-bottom">
                                                        <Row>
                                                            <Col md="6">
                                                                <h6 className="m-0">Détails</h6>
                                                            </Col>
                                                            <Col md="6" className="text-right">
                                                                <Button
                                                                    className="block-center"
                                                                    disabled={this.props.users.loading}
                                                                    onClick={() => this.updateDetails()}>
                                                                    Enregistrer
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <Row className="m-0">
                                                            <Col md="3" className="form-group">
                                                                <label>Civilité</label>
                                                                <FormSelect
                                                                    name="civility"
                                                                    onChange={this.handleChange}
                                                                    className={this.props.practitioners.data.civility ? '' : 'missing'}
                                                                    value={this.state.civility}
                                                                    defaultValue={this.props.practitioners.data.civility}
                                                                >
                                                                    <option value="">-</option>
                                                                    {Object.entries(getCivilities()).map(([key, value]) => (
                                                                        <option key={key} value={key}>{value}</option>
                                                                    ))}
                                                                </FormSelect>
                                                            </Col>
                                                            <Col md="5" className="form-group">
                                                                <label>Nom</label>
                                                                <FormInput
                                                                    type="text"
                                                                    name="last_name"
                                                                    defaultValue={this.props.practitioners.data.last_name}
                                                                    value={this.last_name}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Col>
                                                            <Col md="4" className="form-group">
                                                                <label>Prénom</label>
                                                                <FormInput
                                                                    name="first_name"
                                                                    defaultValue={this.props.practitioners.data.first_name}
                                                                    value={this.first_name}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label>Date de naissance</label>
                                                                <InputGroup
                                                                    className={this.props.practitioners.data.birth_date === null && 'missing'}
                                                                    seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">calendar_today</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        name="birth_date"
                                                                        defaultValue={this.props.practitioners.data.birth_date && dateFormat(new Date(this.props.practitioners.data.birth_date), "dd/mm/yyyy")}
                                                                        placeholder="jj/mm/aaaa"
                                                                        value={this.birth_date}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label htmlFor="userLocation">Pays de résidence</label>
                                                                <InputGroup seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">&#xE0C8;</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        name="country"
                                                                        defaultValue={this.props.practitioners.data.country}
                                                                        onChange={this.handleChange}
                                                                        value={this.country}
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label htmlFor="phoneNumber">Téléphone</label>
                                                                <InputGroup seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">&#xE0CD;</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        name="phone"
                                                                        defaultValue={this.props.practitioners.data.phone}
                                                                        value={this.phone}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label htmlFor="emailAddress">Email</label>
                                                                <InputGroup seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">&#xE0BE;</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        name="email"
                                                                        defaultValue={this.props.practitioners.data.email}
                                                                        value={this.email}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md="12" className="form-group">
                                                                <label>Identifiant technique</label>
                                                                <CopyText
                                                                    text={this.props.practitioners.data.id}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label>Date d'inscription</label>
                                                                <InputGroup seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">calendar_today</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        defaultValue={this.props.practitioners.data.created_at && dateFormat(new Date(this.props.practitioners.data.created_at), "dd/mm/yyyy HH:MM")}
                                                                        disabled
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <label>Dernière mise à jour</label>
                                                                <InputGroup seamless>
                                                                    <InputGroupAddon type="prepend">
                                                                        <InputGroupText>
                                                                            <i className="material-icons practitioner-color">calendar_today</i>
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <FormInput
                                                                        defaultValue={this.props.practitioners.data.updated_at && dateFormat(new Date(this.props.practitioners.data.updated_at), "dd/mm/yyyy HH:MM")}
                                                                        disabled
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                                <Card small className="edit-user-details mt-3">
                                                    <CardHeader className="border-bottom">
                                                        <Row>
                                                            <Col md="12">
                                                                <h6 className="m-0">Réinitialiser le mot de passe</h6>
                                                            </Col>
                                                        </Row>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <Row className="m-0">
                                                            <Col md="12" className="form-group center">
                                                                <Button
                                                                    className="block-center"
                                                                    disabled={this.props.users.loading}
                                                                    onClick={this.resetPasswordUser}>
                                                                    Générer un nouveau lien
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <Col md="12" className="form-group">
                                                            <label>Lien</label>
                                                            <CopyText
                                                                text={this.props.users.data.token}
                                                            />
                                                        </Col>
                                                    </CardBody>
                                                </Card>
                                                <Card small className="edit-user-details mt-3">
                                                    <CardHeader className="border-bottom">
                                                        <Row>
                                                            <Col md="12">
                                                                <h6 className="m-0">Synchronisation Platform</h6>
                                                            </Col>
                                                        </Row>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <Row className="m-0">
                                                            <Col md="12" className="form-group center">
                                                                <Button
                                                                    className="block-center"
                                                                    disabled={this.props.users.loading}
                                                                    onClick={this.syncPlatform}>
                                                                    Forcer une synchronisation
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                            <Col lg="8" className="mx-auto">
                                                <Row>
                                                    <Col lg="5">
                                                        <CardStat
                                                            label="Total de consultations"
                                                            value={this.props.practitioners.data.appointment_new_count +
                                                                this.props.practitioners.data.appointment_cancel_count +
                                                                this.props.practitioners.data.appointment_confirm_count +
                                                                this.props.practitioners.data.appointment_terminate_count +
                                                                this.props.practitioners.data.appointment_close_count}
                                                            classColor="practitioner-color"
                                                        />
                                                    </Col>
                                                    <Col lg="7">
                                                        <CardProgress label={"Profil"}
                                                                      value={this.calculateProfilePercentage(this.props.practitioners.data)}/>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col lg="3">
                                                        <CardStat
                                                            label="Consultations annulées"
                                                            value={this.props.practitioners.data.appointment_cancel_count}
                                                            classColor="practitioner-color"
                                                        />
                                                    </Col>

                                                    <Col lg="3">
                                                        <CardStat
                                                            label="Consultations confirmées"
                                                            value={this.props.practitioners.data.appointment_confirm_count}
                                                            classColor="practitioner-color"
                                                        />
                                                    </Col>
                                                    <Col lg="3">
                                                        <CardStat
                                                            label="Consultations sans documents générés"
                                                            value={this.props.practitioners.data.appointment_terminate_count}
                                                            classColor="practitioner-color"
                                                        />
                                                    </Col>
                                                    <Col lg="3">
                                                        <CardStat
                                                            label="Consultations terminées"
                                                            value={this.props.practitioners.data.appointment_close_count}
                                                            classColor="practitioner-color"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col lg="12">
                                                        <Card small className="edit-user-details mb-4">
                                                            <CardHeader className="border-bottom">
                                                                <h6 className="m-0">Renseignements activité</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <label>RPPS</label>
                                                                        <FormInput
                                                                            name="rpps"
                                                                            value={this.rpps}
                                                                            onChange={this.handleChange}
                                                                            defaultValue={this.props.practitioners.data.rpps}
                                                                            className={(this.props.practitioners.data.adeli === null && this.props.practitioners.data.rpps === null) && 'missing'}
                                                                        />
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <label>ADELI/AM</label>
                                                                        <FormInput
                                                                            name="adeli"
                                                                            value={this.adeli}
                                                                            onChange={this.handleChange}
                                                                            type="text"
                                                                            className={(this.props.practitioners.data.adeli === null && this.props.practitioners.data.rpps === null) && 'missing'}
                                                                            defaultValue={this.props.practitioners.data.adeli}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <label>Spécialité</label>
                                                                        <FormSelect
                                                                            name="main_specialty"
                                                                            onChange={this.handleChange}
                                                                            value={this.main_specialty}
                                                                            className={this.props.practitioners.data.speciality === null && 'missing'}
                                                                        >
                                                                            {this.props.practitioners.data.main_specialty === null ?
                                                                                <option selected>Pas de spécialité renseignée</option>
                                                                                : <option>Pas de spécialité renseignée</option>
                                                                            }
                                                                            {typeof this.props.specialties.data.data === "object" ?
                                                                                Object.entries(this.props.specialties.data.data).map((value) => (
                                                                                    typeof value[1] === 'object' ?
                                                                                        <option value = {value[1].id}
                                                                                                selected = {
                                                                                                    typeof this.props.practitioners.data.main_specialty === 'object'
                                                                                                      && this.props.practitioners.data.main_specialty !== null
                                                                                                      && this.props.practitioners.data.main_specialty.id === value[1].id
                                                                                                }
                                                                                        >
                                                                                          {value[1].name}
                                                                                        </option>
                                                                                        : ''
                                                                                ))
                                                                                : ''
                                                                            }
                                                                        </FormSelect>
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <label htmlFor="userTags">Autres spécialités</label>
                                                                        <TagsInput
                                                                            value={this.props.practitioners.data.specialties ? this.props.practitioners.data.specialties.map(value => value.name) : ([])}
                                                                            inputProps={{placeholder: ''}}
                                                                            disabled
                                                                        />
                                                                        <FormSelect
                                                                            name="specialties"
                                                                            value={this.specialties}
                                                                            onChange={this.handleChangeArray}
                                                                            multiple
                                                                        >
                                                                          {this.props.practitioners.data.specialties === null ?
                                                                              <option value = {null} selected>Pas de spécialité renseignée</option>
                                                                              : <option value = {null}>Pas de spécialité renseignée</option>
                                                                          }
                                                                            {typeof this.props.specialties.data.data === "object" ?
                                                                                Object.entries(this.props.specialties.data.data).map((value) => (
                                                                                    typeof value[1] === 'object' ?
                                                                                        <option value = {value[1].id}
                                                                                                selected = {
                                                                                                    typeof this.props.practitioners.data.specialties === 'object'
                                                                                                      && this.props.practitioners.data.specialties !== null
                                                                                                      && this.props.practitioners.data.specialties.filter(specialty => specialty.id === value[1].id).length > 0
                                                                                                    }
                                                                                        >
                                                                                          {value[1].name}
                                                                                        </option>
                                                                                        : ''
                                                                                ), this)
                                                                                : ''
                                                                            }
                                                                        </FormSelect>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <label>Convention</label>
                                                                        <FormSelect
                                                                            className={this.props.practitioners.data.convention === null && 'missing'}
                                                                            value={this.convention}
                                                                            onChange={this.handleChange}
                                                                            name="convention"
                                                                        >
                                                                            {typeof this.props.conventions.data.data === "object" ?
                                                                                Object.entries(this.props.conventions.data.data)
                                                                                    .map((value) => (
                                                                                            typeof value[1] === 'object' ?
                                                                                                typeof this.props.practitioners.data.convention === 'object' && this.props.practitioners.data.convention !== null && this.props.practitioners.data.convention.id === value[1].id ?
                                                                                                    <option value={value[1].id}
                                                                                                            selected>
                                                                                                        {value[1].name}
                                                                                                    </option> :
                                                                                                    <option value={value[1].id}>
                                                                                                        {value[1].name}
                                                                                                    </option>
                                                                                                : ''
                                                                                        )
                                                                                        , this)
                                                                                : ''
                                                                            }
                                                                        </FormSelect>
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <label>Fuseau horaire</label>
                                                                        <FormSelect disabled>
                                                                            <option
                                                                                defaultValue>{this.props.practitioners.data.timezone}</option>
                                                                        </FormSelect>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <label>Type d'organisation territoriale</label>
                                                                        <FormSelect
                                                                            name="territorial_organization_type"
                                                                            value={this.territorial_organization_type}
                                                                            onChange={this.handleChange}
                                                                        >
                                                                            <option value="null">Je ne fais pas partie d'une
                                                                                organisation territoriale
                                                                            </option>
                                                                            <option value="cpts"
                                                                                    selected={this.props.practitioners.data.territorial_organization_type === 'cpts'}>CPTS
                                                                            </option>
                                                                            <option value="esp"
                                                                                    selected={this.props.practitioners.data.territorial_organization_type === 'esp'}>ESP
                                                                            </option>
                                                                            <option value="msp"
                                                                                    selected={this.props.practitioners.data.territorial_organization_type === 'msp'}>MSP
                                                                            </option>
                                                                            <option value="cds"
                                                                                    selected={this.props.practitioners.data.territorial_organization_type === 'cds'}>CDS
                                                                            </option>
                                                                            <option value="other"
                                                                                    selected={this.props.practitioners.data.territorial_organization_type === 'other'}>Autre
                                                                            </option>
                                                                        </FormSelect>
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <label>Nom de l'organisation territoriale</label>
                                                                        <FormInput
                                                                            defaultValue={this.props.practitioners.data.territorial_organization_name}
                                                                            name="territorial_organization_name"
                                                                            value={this.territorial_organization_name}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </Col>
                                                                    <Col md="12" className="form-group">
                                                                        <label htmlFor="userBio">Biographie</label>
                                                                        <FormTextarea
                                                                            name="description"
                                                                            onChange={this.handleChange}
                                                                            value={this.description}
                                                                            style={{minHeight: "87px"}}
                                                                            defaultValue={this.props.practitioners.data.description}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                            <CardHeader className="card-header-border">
                                                                <h6 className="m-0">Renseignements cabinet médical</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <label>Téléphone du cabinet</label>
                                                                        <InputGroup seamless>
                                                                            <InputGroupAddon type="prepend">
                                                                                <InputGroupText>
                                                                                    <i className="material-icons practitioner-color">&#xE0CD;</i>
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <FormInput
                                                                                name="practice_phone"
                                                                                onChange={this.handleChange}
                                                                                value={this.practice_phone}
                                                                                defaultValue={this.props.practitioners.data.practice_phone}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <label>Email sécurisée</label>
                                                                        <InputGroup seamless>
                                                                            <InputGroupAddon type="prepend">
                                                                                <InputGroupText>
                                                                                    <i className="material-icons practitioner-color">&#xE0BE;</i>
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <FormInput
                                                                                defaultValue={this.props.practitioners.data.secured_email}
                                                                                name="secured_email"
                                                                                onChange={this.handleChange}
                                                                                value={this.secured_email}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="m-0">
                                                                    <Col md="4" className="form-group">
                                                                        <label>Adresse</label>
                                                                        <InputGroup seamless>
                                                                            <InputGroupAddon type="prepend">
                                                                                <InputGroupText>
                                                                                    <i className="material-icons practitioner-color">&#xE0C8;</i>
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <FormInput
                                                                                defaultValue={this.props.practitioners.data.practice_address}
                                                                                name="practice_address"
                                                                                value={this.practice_address}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>

                                                                    <Col md="4" className="form-group">
                                                                        <label>Code Postal</label>
                                                                        <InputGroup seamless>
                                                                            <InputGroupAddon type="prepend">
                                                                                <InputGroupText>
                                                                                    <i className="material-icons practitioner-color">&#xE0C8;</i>
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <FormInput
                                                                                defaultValue={this.props.practitioners.data.practice_zip_code}
                                                                                name="practice_zip_code"
                                                                                value={this.practice_zip_code}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>

                                                                    <Col md="4" className="form-group">
                                                                        <label>Ville</label>
                                                                        <InputGroup seamless>
                                                                            <InputGroupAddon type="prepend">
                                                                                <InputGroupText>
                                                                                    <i className="material-icons practitioner-color">&#xE0C8;</i>
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <FormInput
                                                                                defaultValue={this.props.practitioners.data.practice_city}
                                                                                name="practice_city"
                                                                                value={this.practice_city}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>

                                                            <CardHeader className="card-header-border">
                                                                <h6 className="m-0">Liste des actes</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                {this.props.practitioners.data.products && this.props.practitioners.data.products.map(function (product, key) {
                                                                    return (
                                                                        <Row className="m-0" key={key}>
                                                                            <Col md="4" className="form-group">
                                                                                <label>Nom</label>
                                                                                <FormInput
                                                                                    type="text"
                                                                                    defaultValue={product.name}
                                                                                    disabled
                                                                                />
                                                                            </Col>
                                                                            <Col md="2" className="form-group">
                                                                                <label>Tarif</label>
                                                                                <InputGroup seamless>
                                                                                    <FormInput
                                                                                        type="text"
                                                                                        defaultValue={product.unit_price / 100}
                                                                                        disabled
                                                                                    />
                                                                                    <InputGroupAddon type="append">
                                                                                        <InputGroupText>
                                                                                            €
                                                                                        </InputGroupText>
                                                                                    </InputGroupAddon>
                                                                                </InputGroup>
                                                                            </Col>
                                                                            <Col md="2" className="form-group">
                                                                                <label>Durée</label>
                                                                                <InputGroup seamless>
                                                                                    <FormInput
                                                                                        type="text"
                                                                                        defaultValue={product.duration}
                                                                                        disabled
                                                                                    />
                                                                                    <InputGroupAddon type="append">
                                                                                        <InputGroupText>
                                                                                            minutes
                                                                                        </InputGroupText>
                                                                                    </InputGroupAddon>
                                                                                </InputGroup>

                                                                            </Col>
                                                                            <Col md="4" className="form-group">
                                                                                <label>Canal</label>
                                                                                <FormSelect value={product.channel}
                                                                                            disabled>
                                                                                    {Object.entries(getChannels()).map(([key, value]) => (
                                                                                        <option key={key}
                                                                                                value={key}>{value}</option>
                                                                                    ))}
                                                                                </FormSelect>
                                                                            </Col>
                                                                        </Row>
                                                                    );
                                                                })}
                                                            </CardBody>

                                                            <CardHeader className="card-header-border">
                                                                <h6 className="m-0">Renseignements de facturation</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <Row className="m-0">
                                                                    <Col md="4" className="form-group">
                                                                        <label>IBAN</label>
                                                                        <FormInput
                                                                            type="text"
                                                                            defaultValue={this.props.practitioners.data.iban}
                                                                            name="iban"
                                                                            value={this.iban}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row className="m-0">
                                                                    <Col md="4" className="form-group">
                                                                        <Form onSubmit={this.addBillingContacts}>
                                                                            <FormGroup>
                                                                                <label>Contacts facturation</label>
                                                                                <InputGroup>
                                                                                    <FormInput
                                                                                        type="email"
                                                                                    />
                                                                                    <InputGroupAddon type="append">
                                                                                        <Button type="submit"
                                                                                                outline>Ajouter</Button>
                                                                                    </InputGroupAddon>
                                                                                </InputGroup>
                                                                            </FormGroup>
                                                                            <ul className="contact_facturation_list">
                                                                                {this.props.practitioners.data.billing_contacts ?
                                                                                    Object.entries(this.props.practitioners.data.billing_contacts).map((contact) => (
                                                                                        <li data-email={contact[1].email}>{contact[1].email}
                                                                                            <span
                                                                                                onClick={this.removeContact}><i
                                                                                                className="material-icons remove_contact">cancel</i></span>
                                                                                        </li>
                                                                                    )) : ''
                                                                                }
                                                                            </ul>
                                                                        </Form>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>

                                                            <CardHeader className="card-header-border">
                                                                <h6 className="m-0">Services disponibles</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            className="my-auto"
                                                                            disabled={this.props.practitioners.loading}
                                                                            checked={this.props.practitioners.data.searchable}
                                                                            onChange={this.enableSearchPatient}
                                                                        >
                                                                            Recherche par les patients
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            className="my-auto"
                                                                            disabled={this.props.practitioners.loading}
                                                                            checked={this.props.practitioners.data.claim_form_enabled}
                                                                            onChange={this.enableFSE}
                                                                        >
                                                                            Édition FSE
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            className="my-auto"
                                                                            checked={this.props.practitioners.data.card_payment_activated}
                                                                            onChange={this.enableCardPayment}
                                                                        >
                                                                            Paiement par carte bleue
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            className="my-auto"
                                                                            disabled={this.props.practitioners.loading}
                                                                            checked={this.props.practitioners.data.auto_confirm_appointment}
                                                                            onChange={this.enableAutoConfirm}
                                                                        >
                                                                            Confirmation automatique des rendez-vous
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            className="my-auto"
                                                                            disabled={this.props.practitioners.loading}
                                                                            checked={this.props.practitioners.data.instant_encounters_enabled}
                                                                            onChange={this.enableInstantAppointment}
                                                                        >
                                                                            RDV hors patientèle
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>

                                                            <CardHeader className="card-header-border">
                                                                <h6 className="m-0">Rôles utilisateur</h6>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <Row className="mb-3">
                                                                    <Col className="d-flex status-profil">
                                                                        <FormCheckbox
                                                                            toggle
                                                                            disabled={this.props.practitioners.loading}
                                                                            className="my-auto"
                                                                            checked={this.props.practitioners.data.is_restricted}
                                                                            onChange={this.setRestricted}
                                                                        >
                                                                            Rôle Restreint
                                                                        </FormCheckbox>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        )}
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        practitioners: state['practitioners'],
        users: state['users'],
        specialties: state['specialties'],
        conventions: state['conventions']
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (e) => dispatch(requestProfilPractitioner(e)),
    loadSpecialties: () => dispatch(requestSpecialties()),
    loadConventions: () => dispatch(requestConventions()),
    updatePractitioner: (e) => dispatch(updatePractitionerData(e)),
    resetPassword: (e) => dispatch(resetPasswordUser(e)),
    syncPlatform: (e) => dispatch(synchronisePlatform(e)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profil);



// WEBPACK FOOTER //
// ./src/views/Practitioners/Profil.js